import { makeEntityScaffold } from '@classpass/saga-tools';
import { FitnessTrends } from 'derivers/FitnessTrends';

const KEY = 'SAGA.API.FITNESS_TRENDS';

export const fitnessTrendsMember = makeEntityScaffold(`${KEY}.GET_MEMBER`, (client, year, memberHash) =>
  client.statics.fitnessTrendsMember(year, memberHash).then(data => FitnessTrends.member(data))
);
